import React, { useState } from "react";
import { IVoiceType } from "types";
import { HorizontalSlider } from "components/HorizontalSlider";
import { AudioBoxSC } from "./styled";

interface IAudioBoxProps {
    voice?: IVoiceType;
    setVoice: (voice: IVoiceType) => void;
    speed: number;
    setSpeed: (val: number) => void;
}

export const AudioBox = ({ voice, setVoice, speed, setSpeed }: IAudioBoxProps) => {
    const [background, setBackground] = useState<boolean>(false);
    const rounded = (number: number) => Math.floor(number * 10) / 10;

    return (
        <AudioBoxSC>
            <div className="p_b_voice0">
                <div>Voice:</div>

                <select
                    style={{ width: "180px" }}
                    value={voice}
                    onChange={(e) => {
                        setVoice(e.target.value as IVoiceType);
                    }}
                >
                    <option value="male">Oleg Torsunov</option>
                    <option value="male1">Audience: Male</option>
                    <option value="female">Audience: Female</option>
                    <option value="none">Without translation</option>
                </select>
            </div>

            <div className="p_b_speed">
                <b>
                    speed of
                    <br /> speech
                </b>
                <HorizontalSlider
                    value={speed * 100}
                    min={70}
                    max={120}
                    width={200}
                    step={10}
                    onValueChange={(val: number) => setSpeed(rounded(val / 100))}
                />
                <b>{rounded(speed)}</b>
            </div>

            <div className="p_b_speed">
                <label>
                    Sound background:{" "}
                    <input
                        type="checkbox"
                        checked={background}
                        onChange={(e) => {
                            setBackground(e.target.checked);
                        }}
                    />
                </label>
            </div>
        </AudioBoxSC>
    );
};
